import { useCallback } from 'react'
import { InfoOutlined } from '@mui/icons-material'

import { openWisDetailsModal } from 'app/entities/store/modalsSlice'
import { useAppDispatch } from 'app/hooks'

const SavedStateInfoButton = () => {
  const dispatch = useAppDispatch()

  const handleOpenModal = useCallback(() => {
    dispatch(openWisDetailsModal())
  }, [dispatch])

  return (
    <button className='text-gray-700' onClick={handleOpenModal}>
      <InfoOutlined />
    </button>
  )
}

export default SavedStateInfoButton
